import {AfterContentInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {Store} from '@ngrx/store';
import {AppState} from '../../../state/reducers';
import {AddMediaFolder} from '../../state/actions';

@Component({
  selector: 'add-folder',
  templateUrl: './add-folder.component.html',
  styleUrls: ['./add-folder.component.scss']
})
export class AddMediaFolderComponent implements OnInit, AfterContentInit {
  @ViewChild('nameInput') nameInput?: ElementRef;
  form = new FormGroup({
    name: new FormControl('', Validators.required),
  });

  constructor(
    public ref: DynamicDialogRef,
    private store: Store<AppState>,
    ) { }

  ngOnInit(): void {
  }

  ngAfterContentInit(): void {
    setTimeout(() => {
      if (this.nameInput) {
        this.nameInput.nativeElement.focus();
      }
    }, 50);
  }

  submit(): void {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      control?.markAsTouched({ onlySelf: true });
    });

    if (this.form.valid && this.form.controls.name.value) {
      this.store.dispatch(AddMediaFolder({
        folder: {
          name: this.form.controls.name.value,
        }
      }));
      
      this.ref.close();
    }
  }
}
